import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'

import createSagaMiddleware from 'redux-saga'

import reducer from './rootReducer'
import rootSaga from './rootSaga'





const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false, // if true than we can't use callbacks in any action
    }).concat(sagaMiddleware),
})

sagaMiddleware.run(rootSaga)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
